'use strict';

const PermissionsUtil = {
    _checkPermissionInObject: function(permissionsObj={}, permissionName) {
        return (
            !!permissionsObj
            && !!permissionsObj[permissionName]
        );
    },

    _checkPermissionInEitherObject: function(permissionsObj1={}, permissionsObj2={}, permissionName) {
        return (
            PermissionsUtil._checkPermissionInObject(permissionsObj1, permissionName)
            || PermissionsUtil._checkPermissionInObject(permissionsObj2, permissionName)
        );
    },

    canManageLevel: function(actionTakerChannelPermissions={}) {
        return PermissionsUtil._checkPermissionInObject(actionTakerChannelPermissions, 'manageLevel');
    },

    canManageSubscription: function(actionTakerChannelPermissions={}) {
        return PermissionsUtil._checkPermissionInObject(actionTakerChannelPermissions, 'manageSubscription');
    },

    canDoOrgActions: function(actionTakerChannelPermissions={}) {
        return PermissionsUtil._checkPermissionInObject(actionTakerChannelPermissions, 'orgActions');
    },

    canViewIntegrationTags: function(actionTakerChannelPermissions={}) {
        return PermissionsUtil._checkPermissionInObject(actionTakerChannelPermissions, 'viewIntegrationTags');
    },

    canManageActMetaTags: function(actionTakerChannelPermissions={}) {
        return PermissionsUtil._checkPermissionInObject(actionTakerChannelPermissions, 'manageActMetaTags');
    },

    canViewActMetaTagsForAct: function(actionTakerChannelPermissions={}, actionTakerProjectPermissions={}) {
        return PermissionsUtil._checkPermissionInEitherObject(actionTakerChannelPermissions, actionTakerProjectPermissions, 'viewActMetaTagsForAct');
    },

    canManageActMetaTagsForAct: function(actionTakerChannelPermissions={}, actionTakerProjectPermissions={}) {
        return PermissionsUtil._checkPermissionInEitherObject(actionTakerChannelPermissions, actionTakerProjectPermissions, 'manageActMetaTagsForAct');
    },

    canManageProjectTags: function(actionTakerChannelPermissions={}, actionTakerProjectPermissions={}) {
        return PermissionsUtil._checkPermissionInEitherObject(actionTakerChannelPermissions, actionTakerProjectPermissions, 'manageProjectTags');
    },

    // note: manageActivityTags does not currently exist on any project roles
    canManageActivityTags: function(actionTakerChannelPermissions={}, actionTakerProjectPermissions={}) {
        return PermissionsUtil._checkPermissionInEitherObject(actionTakerChannelPermissions, actionTakerProjectPermissions, 'manageActivityTags');
    },

    viewDetailedChannelAnalytics: function(actionTakerChannelPermissions={}) {
        return PermissionsUtil._checkPermissionInObject(actionTakerChannelPermissions, 'viewAnalytics');
    },

    canCreateAdHocAssignment: function(actionTakerChannelPermissions={}, actionTakerProjectPermissions={}) {
        return PermissionsUtil._checkPermissionInEitherObject(actionTakerChannelPermissions, actionTakerProjectPermissions, 'createAdHocAssignment');
    },

    canCreateGoogleClassroom: function(actionTakerChannelPermissions={}, actionTakerProjectPermissions={}) {
        return PermissionsUtil._checkPermissionInEitherObject(actionTakerChannelPermissions, actionTakerProjectPermissions, 'createGoogleClassroom');
    },

    canCreateNewActivity: function(actionTakerChannelPermissions={}, actionTakerProjectPermissions={}) {
        return PermissionsUtil._checkPermissionInEitherObject(actionTakerChannelPermissions, actionTakerProjectPermissions, 'createNewActivity');
    },

    canEditProjectCollaborators: function(actionTakerChannelPermissions={}, actionTakerProjectPermissions={}) {
        return PermissionsUtil._checkPermissionInEitherObject(actionTakerChannelPermissions, actionTakerProjectPermissions, 'editProjectCollaborators');
    },

    canViewProjectCollaborators: function(actionTakerChannelPermissions={}, actionTakerProjectPermissions={}) {
        return PermissionsUtil._checkPermissionInEitherObject(actionTakerChannelPermissions, actionTakerProjectPermissions, 'viewProjectCollaborators');
    },

    canRenameProject: function(actionTakerChannelPermissions={}, actionTakerProjectPermissions={}) {
        return PermissionsUtil._checkPermissionInEitherObject(actionTakerChannelPermissions, actionTakerProjectPermissions, 'renameProject');
    },

    canEditProjectDescription: function(actionTakerChannelPermissions={}, actionTakerProjectPermissions={}) {
        return PermissionsUtil._checkPermissionInEitherObject(actionTakerChannelPermissions, actionTakerProjectPermissions, 'editProjectDescription');
    },

    viewDetailedProjectAnalytics: function(actionTakerChannelPermissions={}, actionTakerProjectPermissions={}) {
        return PermissionsUtil._checkPermissionInEitherObject(actionTakerChannelPermissions, actionTakerProjectPermissions, 'viewAnalytics');
    },

    canCreateProject: function(actionTakerChannelPermissions={}) {
        return PermissionsUtil._checkPermissionInObject(actionTakerChannelPermissions, 'createProject');
    },

    canDuplicateProject: function(actionTakerChannelPermissions={}) {
        return PermissionsUtil._checkPermissionInObject(actionTakerChannelPermissions, 'duplicateProject');
    },

    // NOTE: deleteProject permission only currently exists in channel-level roles
    canDeleteProject: function(actionTakerChannelPermissions={}, actionTakerProjectPermissions={}) {
        return PermissionsUtil._checkPermissionInEitherObject(actionTakerChannelPermissions, actionTakerProjectPermissions, 'deleteProject');
    },

    canTransferProject: function(actionTakerChannelPermissions={}) {
        return PermissionsUtil._checkPermissionInObject(actionTakerChannelPermissions, 'transferProject');
    },

    canViewFolders: function(actionTakerChannelPermissions={}) {
        return PermissionsUtil._checkPermissionInObject(actionTakerChannelPermissions, 'viewFolders');
    },

    canCreateFolder: function(actionTakerChannelPermissions={}) {
        return PermissionsUtil._checkPermissionInObject(actionTakerChannelPermissions, 'createFolder');
    },

    canDeleteFolder: function(actionTakerChannelPermissions={}) {
        return PermissionsUtil._checkPermissionInObject(actionTakerChannelPermissions, 'deleteFolder');
    },

    canEditActivity: function(actionTakerChannelPermissions={}, actionTakerProjectPermissions={}) {
        return PermissionsUtil._checkPermissionInEitherObject(actionTakerChannelPermissions, actionTakerProjectPermissions, 'editActivity');
    },

    canReviewActivity: function(actionTakerChannelPermissions={}, actionTakerProjectPermissions={}) {
        return PermissionsUtil._checkPermissionInEitherObject(actionTakerChannelPermissions, actionTakerProjectPermissions, 'reviewActivity');
    },

    canPreviewActivity: function(actionTakerChannelPermissions={}, actionTakerProjectPermissions={}) {
        return PermissionsUtil._checkPermissionInEitherObject(actionTakerChannelPermissions, actionTakerProjectPermissions, 'previewActivity');
    },

    canRenameActivity: function(actionTakerChannelPermissions={}, actionTakerProjectPermissions={}) {
        return PermissionsUtil._checkPermissionInEitherObject(actionTakerChannelPermissions, actionTakerProjectPermissions, 'renameActivity');
    },

    canDuplicateActivity: function(actionTakerChannelPermissions={}, actionTakerProjectPermissions={}) {
        return PermissionsUtil._checkPermissionInEitherObject(actionTakerChannelPermissions, actionTakerProjectPermissions, 'duplicateActivity');
    },

    canMoveActivity: function(actionTakerChannelPermissions={}, actionTakerProjectPermissions={}) {
        return PermissionsUtil._checkPermissionInEitherObject(actionTakerChannelPermissions, actionTakerProjectPermissions, 'moveActivity');
    },

    canDeleteActivity: function(actionTakerChannelPermissions={}, actionTakerProjectPermissions={}) {
        return PermissionsUtil._checkPermissionInEitherObject(actionTakerChannelPermissions, actionTakerProjectPermissions, 'deleteActivity');
    },

    canPublishActivity: function(actionTakerChannelPermissions={}, actionTakerProjectPermissions={}) {
        return PermissionsUtil._checkPermissionInEitherObject(actionTakerChannelPermissions, actionTakerProjectPermissions, 'publishActivity');
    },

    canAdministerAssignment: function(actionTakerChannelPermissions={}) {
        return PermissionsUtil._checkPermissionInObject(actionTakerChannelPermissions, 'administerAssignment');
    },

    canViewAssignment: function(actionTakerAssignmentPermissions={}) {
        return PermissionsUtil._checkPermissionInObject(actionTakerAssignmentPermissions, 'viewAssignment');
    },

    canViewCourse: function(actionTakerCoursePermissions={}) {
        return PermissionsUtil._checkPermissionInObject(actionTakerCoursePermissions, 'viewCourse');
    },

    canEditAssignment: function(actionTakerAssignmentPermissions={}) {
        return PermissionsUtil._checkPermissionInObject(actionTakerAssignmentPermissions, 'editAssignment');
    },

    canExportAssignment: function(actionTakerAssignmentPermissions={}) {
        return PermissionsUtil._checkPermissionInObject(actionTakerAssignmentPermissions, 'exportAssignment');
    },

    canPlayGame: function(actionTakerAssignmentPermissions={}) {
        return PermissionsUtil._checkPermissionInObject(actionTakerAssignmentPermissions, 'playGame');
    },

    canSeeReports: function(actionTakerAssignmentPermissions={}) {
        return PermissionsUtil._checkPermissionInObject(actionTakerAssignmentPermissions, 'seeReports');
    },

    canViewOrgMembers: function(actionTakerChannelPermissions={}) {
        return PermissionsUtil._checkPermissionInObject(actionTakerChannelPermissions, 'viewOrgMembers');
    },

    canViewProjects: function(actionTakerChannelPermissions={}) {
        return PermissionsUtil._checkPermissionInObject(actionTakerChannelPermissions, 'viewProjects');
    },

    canViewActivities: function(actionTakerChannelPermissions={}, actionTakerProjectPermissions={}) {
        return PermissionsUtil._checkPermissionInEitherObject(actionTakerChannelPermissions, actionTakerProjectPermissions, 'viewActivities');
    },

    canViewComments: function(actionTakerChannelPermissions={}, actionTakerProjectPermissions={}) {
        return PermissionsUtil._checkPermissionInEitherObject(actionTakerChannelPermissions, actionTakerProjectPermissions, 'viewComments');
    },

    canAddComment: function(actionTakerChannelPermissions={}, actionTakerProjectPermissions={}) {
        return PermissionsUtil._checkPermissionInEitherObject(actionTakerChannelPermissions, actionTakerProjectPermissions, 'addComment');
    },

    canAssignComment: function(actionTakerChannelPermissions={}, actionTakerProjectPermissions={}) {
        return PermissionsUtil._checkPermissionInEitherObject(actionTakerChannelPermissions, actionTakerProjectPermissions, 'assignComment');
    },

    canChangeCommentStatus: function(actionTakerChannelPermissions={}, actionTakerProjectPermissions={}) {
        return PermissionsUtil._checkPermissionInEitherObject(actionTakerChannelPermissions, actionTakerProjectPermissions, 'changeCommentStatus');
    },

    canBeAssignedComment: function(actionTakerChannelPermissions={}, actionTakerProjectPermissions={}) {
        return PermissionsUtil._checkPermissionInEitherObject(actionTakerChannelPermissions, actionTakerProjectPermissions, 'beAssignedComment');
    },

    canViewValidationReport: function(actionTakerChannelPermissions={}, actionTakerProjectPermissions={}) {
        return (
            PermissionsUtil.canReviewActivity(actionTakerChannelPermissions, actionTakerProjectPermissions)
            || PermissionsUtil.canEditActivity(actionTakerChannelPermissions, actionTakerProjectPermissions)
        );
    },

    canViewPrivacyPolicies: function(actionTakerChannelPermissions={}, actionTakerProjectPermissions={}) {
        return PermissionsUtil._checkPermissionInEitherObject(actionTakerChannelPermissions, actionTakerProjectPermissions, 'viewPrivacyPolicies');
    },

    canEditPrivacyPolicies: function(actionTakerChannelPermissions={}, actionTakerProjectPermissions={}) {
        return PermissionsUtil._checkPermissionInEitherObject(actionTakerChannelPermissions, actionTakerProjectPermissions, 'editPrivacyPolicies');
    },

    canViewActivityPrivacyPolicies: function(actionTakerChannelPermissions={}, actionTakerProjectPermissions={}) {
        return PermissionsUtil._checkPermissionInEitherObject(actionTakerChannelPermissions, actionTakerProjectPermissions, 'viewActivityPrivacyPolicies');
    },

    canEditActivityPrivacyPolicy: function(actionTakerChannelPermissions={}, actionTakerProjectPermissions={}) {
        return PermissionsUtil._checkPermissionInEitherObject(actionTakerChannelPermissions, actionTakerProjectPermissions, 'editActivityPrivacyPolicy');
    },

    canManageActivityShareLink: function(actionTakerChannelPermissions={}, actionTakerProjectPermissions={}) {
        return PermissionsUtil._checkPermissionInEitherObject(actionTakerChannelPermissions, actionTakerProjectPermissions, 'manageActivityShareLink');
    },

    // Short Courses
    canEditShortCourse: function(actionTakerChannelPermissions={}, actionTakerProjectPermissions={}) {
        return PermissionsUtil._checkPermissionInEitherObject(actionTakerChannelPermissions, actionTakerProjectPermissions, 'editShortCourse');
    },

    canReviewShortCourse: function(actionTakerChannelPermissions={}, actionTakerProjectPermissions={}) {
        return PermissionsUtil._checkPermissionInEitherObject(actionTakerChannelPermissions, actionTakerProjectPermissions, 'reviewShortCourse');
    },

    canMoveShortCourse: function(actionTakerChannelPermissions={}, actionTakerProjectPermissions={}) {
        return PermissionsUtil._checkPermissionInEitherObject(actionTakerChannelPermissions, actionTakerProjectPermissions, 'moveShortCourse');
    },

    canRenameShortCourse: function(actionTakerChannelPermissions={}, actionTakerProjectPermissions={}) {
        return PermissionsUtil._checkPermissionInEitherObject(actionTakerChannelPermissions, actionTakerProjectPermissions, 'renameShortCourse');
    },

    canViewShortCourses: function(actionTakerChannelPermissions={}, actionTakerProjectPermissions={}) {
        return PermissionsUtil._checkPermissionInEitherObject(actionTakerChannelPermissions, actionTakerProjectPermissions, 'viewShortCourses');
    },

    canPublishShortCourse: function(actionTakerChannelPermissions={}, actionTakerProjectPermissions={}) {
        return PermissionsUtil._checkPermissionInEitherObject(actionTakerChannelPermissions, actionTakerProjectPermissions, 'publishShortCourse');
    },

    canCreateNewShortCourse: function(actionTakerChannelPermissions={}, actionTakerProjectPermissions={}) {
        return PermissionsUtil._checkPermissionInEitherObject(actionTakerChannelPermissions, actionTakerProjectPermissions, 'createNewShortCourse');
    },

    canDuplicateShortCourse: function(actionTakerChannelPermissions={}, actionTakerProjectPermissions={}) {
        return PermissionsUtil._checkPermissionInEitherObject(actionTakerChannelPermissions, actionTakerProjectPermissions, 'duplicateShortCourse');
    },

    canDeleteShortCourse: function(actionTakerChannelPermissions={}, actionTakerProjectPermissions={}) {
        return PermissionsUtil._checkPermissionInEitherObject(actionTakerChannelPermissions, actionTakerProjectPermissions, 'deleteShortCourse');
    },
};

module.exports = PermissionsUtil;